import { DEMO_IDS, DEMO_IMEI, DEMO_MQTT_USER, DEMO_MQTT_PASSWORD, DEMO_MQTT_TOPIC_PUB, DEMO_MQTT_TOPIC_SUB } from './mock/fixtures/mqttPacket'

export { DEMO_IMEI, DEMO_MQTT_USER, DEMO_MQTT_PASSWORD, DEMO_MQTT_TOPIC_PUB, DEMO_MQTT_TOPIC_SUB }

export const demoRoutes = {
    equipamentoLista: '/equipamento',
    equipamentoNovo: '/equipamento/novo',
    equipamentoEdit: `/equipamento/${DEMO_IDS.equipamento}/editar`,
    parametrizacaoNovo: `/campo-parametrizado/${DEMO_IDS.equipamento}/novo`,
    perfilLista: '/perfil/cliente',
    perfilNovo: '/perfil/cliente/novo',
    clienteLista: '/cliente',
    clienteNovo: '/cliente/novo',
    monitoradoLista: '/monitorado',
    monitoradoNovo: '/monitorado/novo',
    monitoradoEdit: `/monitorado/${DEMO_IDS.monitorado}/editar`,
    listaMonitorados: '/lista-monitorados',
    status: `/status/${DEMO_IDS.monitorado}`,
    supervisorio: '/supervisorio',
}

export const isDemoAllowedPath = (pathname) => {
    const path = String(pathname || '/')

    if (path === '/') return true

    if (path === '/redirect' || path.startsWith('/redirect/')) return true

    if (path.startsWith('/status/')) {
        return path === `/status/${DEMO_IDS.monitorado}` || path.startsWith(`/status/${DEMO_IDS.monitorado}/`)
    }

    if (path === '/equipamento' || path.startsWith('/equipamento/')) {
        if (path === '/equipamento' || path === '/equipamento/') return true
        if (path === '/equipamento/novo' || path.startsWith('/equipamento/novo/')) return true
        if (path.includes(`/${DEMO_IDS.equipamento}/`)) return true
        return false
    }

    if (path.startsWith('/campo-parametrizado/')) {
        return path.includes(`/${DEMO_IDS.equipamento}/`)
    }

    if (path === '/monitorado' || path.startsWith('/monitorado/')) {
        if (path === '/monitorado' || path === '/monitorado/') return true
        if (path === '/monitorado/novo' || path.startsWith('/monitorado/novo/')) return true
        if (path.includes(`/${DEMO_IDS.monitorado}/`)) return true
        return false
    }

    const allowedPrefixes = ['/perfil/cliente', '/cliente', '/lista-monitorados', '/supervisorio']
    return allowedPrefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))
}

export const setDemoTourResume = (tourName, path, resumeIndex = 0) => {
    try {
        sessionStorage.setItem('hdv_tour_resume', JSON.stringify({ tourName, resumeIndex, path }))
    } catch (error) {}
}

export const dismissSuccessAndContinue = (tourManager, { fromTour, toTour, waitSelector, fallbackPath, delayMs = 80 }) => {
    const modalButtons = Array.from(document.querySelectorAll('.modal.show .modal-footer button, .modal.show button'))
    const closeButton =
        modalButtons.find((button) => /cadastrar um novo|fechar/i.test(button.textContent || '')) ||
        document.querySelector('.modal.show .close')
    closeButton?.click()

    const continueAfterDismiss = () => {
        tourManager.internalNavigation = true
        tourManager.finish(fromTour)

        const startNextTour = () => {
            tourManager.internalNavigation = false
            tourManager.start(toTour, { resumeIndex: 0 })
        }

        if (fallbackPath && tourManager.history) {
            tourManager.history.push(fallbackPath)
            setTimeout(startNextTour, 250)
            return
        }

        if (fallbackPath) {
            tourManager.internalNavigation = false
            setDemoTourResume(toTour, fallbackPath, 0)
            window.location.href = fallbackPath
            return
        }

        if (waitSelector) {
            tourManager.waitForElement(waitSelector).then(startNextTour).catch(startNextTour)
            return
        }

        startNextTour()
    }

    setTimeout(continueAfterDismiss, delayMs)
}

export default { demoRoutes, isDemoAllowedPath, setDemoTourResume, DEMO_MQTT_PASSWORD, DEMO_MQTT_TOPIC_PUB, DEMO_MQTT_TOPIC_SUB, DEMO_IMEI, DEMO_MQTT_USER, }
